import socialItem01 from "/public/assets/images/company/social/soc-sld-itm-new01.png"
import socialItem02 from "/public/assets/images/company/social/soc-sld-itm02.png"
import socialItem03 from "/public/assets/images/company/social/soc-sld-itm03.png"
import socialItem04 from "/public/assets/images/company/social/soc-sld-itm04.png"
import socialItem05 from "/public/assets/images/company/social/soc-sld-itm05.png"
import HistoryImage01 from "/public/assets/images/company/homepage-history/image01.png"
import HistoryImage02 from "/public/assets/images/company/homepage-history/image02.png"
import HistoryImage03 from "/public/assets/images/company/homepage-history/image03.png"
import HistoryImage04 from "/public/assets/images/company/homepage-history/image04.png"
import HistoryImage05 from "/public/assets/images/company/homepage-history/image05.png"
import HistoryImage06 from "/public/assets/images/company/homepage-history/image06.png"
import HistoryImage07 from "/public/assets/images/company/homepage-history/image07.png"
import HistoryImage08 from "/public/assets/images/company/homepage-history/image08.png"
import HistoryImage09 from "/public/assets/images/company/homepage-history/image09.png"
import HistoryImage10 from "/public/assets/images/company/homepage-history/image10.png"
import HistoryImage11 from "/public/assets/images/company/homepage-history/image11.png"
import HistoryImage12 from "/public/assets/images/company/homepage-history/image12.png"
import HistoryImage13 from "/public/assets/images/company/homepage-history/image13.png"
import HistoryImage14 from "/public/assets/images/company/homepage-history/image14.png"
import HistoryImage15 from "/public/assets/images/company/homepage-history/image15.png"
import HistoryImage16 from "/public/assets/images/company/homepage-history/image16.png"
import HistoryImage17 from "/public/assets/images/company/homepage-history/image17.png"
import HistoryImage18 from "/public/assets/images/company/homepage-history/image18.png"
import HistoryImage19 from "/public/assets/images/company/homepage-history/image19.png"
import HistoryImage20 from "/public/assets/images/company/homepage-history/image20.png"
import HistoryImage21 from "/public/assets/images/company/homepage-history/image21.png"
import HistoryImage22 from "/public/assets/images/company/homepage-history/image22.png"
import HistoryImage23 from "/public/assets/images/company/homepage-history/image23.png"
import HistoryImage24 from "/public/assets/images/company/homepage-history/image24.png"


import HistoryImage25 from "/public/assets/images/company/homepage-history/image25.png"
import HistoryImage26 from "/public/assets/images/company/homepage-history/image26.png"
import HistoryImage27 from "/public/assets/images/company/homepage-history/image27.png"
import HistoryImage28 from "/public/assets/images/company/homepage-history/image28.png"



import HistoryImage29 from "/public/assets/images/company/homepage-history/image29.png"
import HistoryImage30 from "/public/assets/images/company/homepage-history/image30.png"
import HistoryImage31 from "/public/assets/images/company/homepage-history/image31.png"
import HistoryImage32 from "/public/assets/images/company/homepage-history/image32.png"
import HistoryImage33 from "/public/assets/images/company/homepage-history/image33.png"
import HistoryImage34 from "/public/assets/images/company/homepage-history/image34.png"
import HistoryImage35 from "/public/assets/images/company/homepage-history/image35.png"
import HistoryImage36 from "/public/assets/images/company/homepage-history/image36.png"
import HistoryImage37 from "/public/assets/images/company/homepage-history/image37.png"



export const HISTORY_MET_ITEMS = [
    {imageItem: HistoryImage01?.src},
    {imageItem: HistoryImage02?.src},
    {imageItem: HistoryImage03?.src},
    {imageItem: HistoryImage04?.src},
]
export const HISTORY_MET_ITEMS01 = [
    {imageItem: HistoryImage01?.src},
    {imageItem: HistoryImage02?.src},
]
export const HISTORY_MET_ITEMS02 = [
    {imageItem: HistoryImage03?.src},
    {imageItem: HistoryImage04?.src},
]
export const HISTORY_RD_ITEMS = [
    {imageItem: HistoryImage05?.src},
    {imageItem: HistoryImage06?.src},
]
export const HISTORY_INNO_ITEMS = [
    {imageItem: HistoryImage07?.src},
    {imageItem: HistoryImage08?.src},
]
export const HISTORY_EURO_ITEMS01 = [
    {imageItem: HistoryImage09?.src},
    {imageItem: HistoryImage10?.src},
]
export const HISTORY_EURO_ITEMS02 = [
    {imageItem: HistoryImage11?.src},
]
export const HISTORY_SYSTEM_ITEMS = [
    {imageItem: HistoryImage12?.src},
    {imageItem: HistoryImage13?.src},
]
export const HISTORY_CELL_ITEMS = [
    {imageItem: HistoryImage14?.src},
    {imageItem: HistoryImage15?.src},
    {imageItem: HistoryImage16?.src},
    {imageItem: HistoryImage17?.src},
    {imageItem: HistoryImage18?.src},
    {imageItem: HistoryImage19?.src},
]

export const HISTORY_CELL_ITEMS01 = [
    {imageItem: HistoryImage14?.src},
    {imageItem: HistoryImage15?.src},
    {imageItem: HistoryImage16?.src},
]

export const HISTORY_CELL_ITEMS02 = [
    {imageItem: HistoryImage17?.src},
    {imageItem: HistoryImage18?.src},
    {imageItem: HistoryImage19?.src},
]
export const HISTORY_DOJIN_ITEMS = [
    {imageItem: HistoryImage20?.src},
    {imageItem: HistoryImage21?.src},
    {imageItem: HistoryImage22?.src},
]
export const HISTORY_DOJIN_ITEMS01 = [
    {imageItem: HistoryImage20?.src},
    {imageItem: HistoryImage21?.src},
]
export const HISTORY_DOJIN_ITEMS02 = [
    {imageItem: HistoryImage22?.src},
]
export const HISTORY_BUHL_ITEMS = [
    {imageItem: HistoryImage23?.src},
    {imageItem: HistoryImage24?.src},
]










export const HISTORY_NGS_ITEMS = [
    {imageItem: HistoryImage25?.src},
    {imageItem: HistoryImage26?.src},
    {imageItem: HistoryImage27?.src},
    {imageItem: HistoryImage28?.src},
]
export const HISTORY_NGS_ITEMS01 = [
    {imageItem: HistoryImage25?.src},
    {imageItem: HistoryImage26?.src},
    {imageItem: HistoryImage27?.src},
]
export const HISTORY_NGS_ITEMS02 = [
    {imageItem: HistoryImage28?.src},
]
export const HISTORY_AIMS_ITEMS = [
    {imageItem: HistoryImage29?.src},
    {imageItem: HistoryImage30?.src},
    {imageItem: HistoryImage31?.src},
]





export const HISTORY_NEXT_BIO_ITEMS = [
    {imageItem: HistoryImage32?.src},
    {imageItem: HistoryImage33?.src},
    {imageItem: HistoryImage34?.src},
]
export const HISTORY_NEXT_BIO_ITEMS01 = [
    {imageItem: HistoryImage32?.src},
    {imageItem: HistoryImage33?.src},
]
export const HISTORY_NEXT_BIO_ITEMS02 = [
    {imageItem: HistoryImage34?.src},
]








export const HISTORY_FDA_ITEMS = [
    {imageItem: HistoryImage35?.src},
    {imageItem: HistoryImage36?.src},
    {imageItem: HistoryImage37?.src},
]

export const HISTORY_FDA_ITEMS01 = [
    {imageItem: HistoryImage35?.src},
    {imageItem: HistoryImage36?.src},
]
export const HISTORY_FDA_ITEMS02 = [
    {imageItem: HistoryImage37?.src},
]













export const SOCIAL_SLIDE_ITEMS = [
    {imageItem: socialItem01?.src},
    {imageItem: socialItem02?.src},
    {imageItem: socialItem03?.src},
    {imageItem: socialItem04?.src},
    {imageItem: socialItem05?.src},
]